import styled from '@emotion/styled';
import {colors, sizes} from "patient-ping-remedy/packages/theme";

export const EventConsumersContainer = styled.div<{ isWithinModal: boolean }>`
  padding: ${(props) => (props.isWithinModal ? `0 ${sizes.medium}` : '0')};
  
  label {
    text-transform: none;
  }
`;

export const BorderedContent = styled.div`
  padding: 20px;
  border: 0.1rem solid ${colors.gray3};
  width: 100%;
  border-radius: 8px;
  background-color: ${colors.white};
  margin-top: ${sizes.small};
`;

